import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomButton from '../../../common/components/UI/Button/Button';
import SearchInput from '../../../common/components/UI/Search/SearchInput';
import './RuleSet.scss';

/**
 * 
 * @param {{
 *  searchValue: string,
 *  setSearchValue: Function,
 *  onCreate: Function,
 * }} props 
 * @returns 
 */
function RuleSetHeader(props){
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'settings'});
    const { searchValue, setSearchValue, onCreate } = props;
    return (
        <div className="rsh-header">
            <div className="create-new-button-container">
                <CustomButton
                    size={'medium'}
                    color={'primary'}
                    onClick={onCreate}
                >
                    {t('ruleSet.addNew')}
                </CustomButton>
            </div>
            <div className="search-input-container">
                <SearchInput
                    fullWidth={true}
                    value={searchValue}
                    placeholder={t('search')}
                    onChange={(e) => setSearchValue(e.target.value)}
                />
            </div>
        </div>
    );
}
export default RuleSetHeader;
